import React, { useRef, useEffect } from "react";
import { useJsApiLoader, Autocomplete } from "@react-google-maps/api";

const libraries = ["places"];

const AddressLable = ({
  formData,
  setFormData,
  field,
  errors,
  address = false,
  getTitle,
}) => {
  const searchInput = useRef(null);
  const autoRef = useRef(null);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries,
  });

  const title = getTitle(field);
  const showAsterisk = !!title && !!field?.isMandatory;

  useEffect(() => {
    if (!isLoaded || !autoRef.current) return;

    const autocomplete = autoRef.current;
    autocomplete.setFields([
      "address_components",
      "geometry",
      "formatted_address",
    ]);

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      if (!place) return;

      const address = place.formatted_address || "";
      setFormData((prev) => ({
        ...prev,
        [field.id]: address,
      }));

      // Optional: move cursor to end of input
      if (searchInput.current) {
        searchInput.current.value = address;
      }
    });
  }, [isLoaded, setFormData, field.id]);

  if (!isLoaded) return <div>Loading...</div>;

  return (
    <>
      <div className="form-label">
        <div className="label-val">
          {title} {showAsterisk && <span className="mandatory-star">*</span>}
        </div>

        {/* {title && (
        <div className="label-val">
          {title} {showAsterisk && }
          </div>
      )} */}
      </div>
      <img
        className={address ? "address-icon" : "addImgss"}
        src="https://suyoolportalpublic.blob.core.windows.net/photos/pin.png"
        alt="Logo"
      />
      <Autocomplete
        onLoad={(ref) => {
          autoRef.current = ref;

          ref.setFields([
            "address_components",
            "geometry",
            "formatted_address",
          ]);
          ref.addListener("place_changed", () => {
            const place = ref.getPlace();
            if (!place) return;

            const address = place.formatted_address || "";

            setFormData((prev) => ({
              ...prev,
              [field.id]: address,
            }));

            if (searchInput.current) {
              searchInput.current.value = address; // move cursor to end
            }
          });
        }}
      >
        <input
          ref={searchInput}
          className="addressinput w-100"
          placeholder="Street, building, city, country"
          name={field.id}
          value={formData[field.id] || ""}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              [field.id]: e.target.value,
            }))
          }
          disabled={field.isDisabled}
          maxLength={field.maxLength || 255}
        />
      </Autocomplete>

      {errors[field.id] && <div className="error">{errors[field.id]}</div>}
    </>
  );
};

export default AddressLable;
